import { render, staticRenderFns } from "./SectionKeyVisualLogo.vue?vue&type=template&id=0450b50c&"
import script from "./SectionKeyVisualLogo.vue?vue&type=script&lang=js&"
export * from "./SectionKeyVisualLogo.vue?vue&type=script&lang=js&"
import style0 from "./SectionKeyVisualLogo.vue?vue&type=style&index=0&id=0450b50c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports